// extracted by mini-css-extract-plugin
export default {"root":"_1R-eJ","small":"_380Bq","normal":"_1mKdC"};